import { IS_REACT_PROMO_QUOTA_PARTNER_PAGE } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getFeatureAbQuotaLanding } from 'reactApp/modules/features/features.selectors';
import { MediaSelectors } from 'reactApp/modules/media/media.selectors';
import { State } from 'reactApp/modules/quotaLanding/quotaLanding.types';
import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getState = (state: RootState): State => state.quotaLanding as State;

const isMobile = (state: RootState): boolean => {
    if (MediaSelectors.getMediaState(state)) {
        return Boolean(MediaSelectors.isMobile(state));
    }

    return EnvironmentSelectors.isMobile();
};

const getAbLandingFeature = createSelector(getFeatureAbQuotaLanding, (feature) => feature === 'b' || IS_REACT_PROMO_QUOTA_PARTNER_PAGE);

export const QuotaLandingSelectors = {
    getState,
    isMobile,
    getAbLandingFeature,
};
